// Email Regex
// must double escape regexes because they evaluate to a string
export const emailRegex = '.+@.+\\..+';
export const strictEmailRegex = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
export const CSV_EXPORT_MESSAGE = 'Exporting CSV file. This may take a few minutes. Please do NOT manually refresh the page as this will cancel the export. We will notify you when it is done.'
export const CSV_EXPORT_SUCCESS_MESSAGE = 'CSV exported successfully.'
export const CURRENCY_MISMATCH_TOOLTIP = 'All Assets must be in the same Origin Currency to use the sum total cost feature.'